const mutations = {
  setListBank: (state, payload) => {
    state.listBank = payload
  },
  setListMomo: (state, payload) => {
    state.listMomo = payload
  },
  setCurrentBusinessAccount: (state, payload) => {
    state.currentBusinessAccount = payload
  },
  setListBankAccount: (state, payload) => {
    state.listBankAccount = payload
  },
  setListMomoAccount: (state, payload) => {
    state.listMomoAccount = payload
  },
  setListTransfer: (state, payload) => {
    state.listTransfer = payload
  },
  setTotalTransfer: (state, payload) => {
    state.totalTransfer = payload
  },
  setListTopUp: (state, payload) => {
    state.listTopUp = payload
  },
  setListTransaction: (state, payload) => {
    state.listAllTransaction = payload
  },
  setTotalTransaction: (state, payload) => {
    state.totalTransaction = payload
  },
  setAvailableBalance: (state, payload) => {
    state.availableBalance = payload
  },
  setListOutgoing: (state, payload) => {
    state.listOutgoing = payload
  },
  setListIncoming: (state, payload) => {
    state.listIncoming = payload
  },
  setListVisaCards: (state, payload) => {
    state.listVisaCards = payload
  }
}
export default mutations
